import React from "react";
import Language from "../language/language";
import { withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";
import { Tag, Button, Modal as ModalAntd } from "antd";
import { $const, $util } from "../../helper";

import PersonInfoNotice from "./personInfoNotice";
import Modal from "../modal/modal";
import ConfirmPersonalInfo from "./confirmPersonalInfo";

import "./stylesheets/selectRole.scss";

const { CheckableTag } = Tag;

@inject("teamStore", "authStore", "gameStore", "languageStore")
@withRouter
@observer
export default class SelectRole extends React.Component {
  state = {
    modalWidth: 457,
    position: undefined,
    positionName: "",
    role: undefined,
    checked: false,
    checkErrorInfo: [],
    btnIsLoading: false,
    // 确认个人信息弹框状态
    confirmPersonalInfoModalState: false
  };

  handleChangePosition = (position, positionName, code) => {
    this.setState({
      position: position,
      positionName
    });
    // this.verify(code);
  };

  handleChangeRole = role => {
    this.setState({
      role: role
    });
  };

  verify = $util.debounce(async code => {
    const userId = this.props.authStore.user && this.props.authStore.user.id;
    const gameId = this.props.gameStore.selectedGame && this.props.gameStore.selectedGame.id;
    const teamId = this.props.teamStore.joinInTeamInfo && this.props.teamStore.joinInTeamInfo.id;
    const checkRes = await $util.verifyPersonalInfo(userId, gameId, teamId, "1", [], code);
    if (checkRes && checkRes.data && checkRes.data.result === 1) {
      this.setState({
        checked: true,
        checkErrorInfo: [],
        btnIsLoading: false
      });
      return;
    }
    this.setState({
      checked: false,
      checkErrorInfo: checkRes && checkRes.data && checkRes.data.res ? checkRes.data.res : [],
      btnIsLoading: false
    });
  });

  closeConfirmPersonalInfoModalState = () => {
    this.setState({
      confirmPersonalInfoModalState: false
    });
  };

  joinTeam = () => {
    // 当前比赛的赛事类型id
    const curGameCategoryId = `${this.props.gameStore.selectedGame.attributes.category_id}`;
    if ($const.CONFIRM_PERSONAL_INFO_GAME_CATEGORY_IDS.includes(curGameCategoryId)) {
      // 只在部分赛事提示“信息确认弹框"
      this.setState({
        confirmPersonalInfoModalState: true
      });
    } else {
      this.confirmPersonalInfo();
    }
  };

  confirmPersonalInfo = () => {
    // if (
    //   (this.state.positionName === "指导老师" || this.state.positionName === "Supervisor") &&
    //   !this.props.authStore.userWorkIsOk
    // ) {
    //   this.props.teamStore.closeSelctRole();
    //   this.props.authStore.showUserWorkNotice("", "");
    //   return;
    // }
    this.props.teamStore
      .joinInTeam({
        variables: {
          input: {
            attributes: {
              teamId: this.props.teamStore.joinInTeamInfo.id,
              memberId: this.props.authStore.user.id.toString(),
              eventRoleId: this.state.role,
              eventPositionId: this.state.position
            }
          }
        }
      })
      .then(() => {
        if (
          this.props.teamStore.applicationTeamInfo &&
          this.props.teamStore.applicationTeamInfo.gappliction
        ) {
          this.props.teamStore.closeSelctRole();
          this.props.history.push("/apply-team-success");
        }
      });
  };

  getPostions = game => {
    let positions = [];
    if (
      game &&
      game.attributes &&
      game.attributes.positions &&
      game.attributes.positions.length > 0
    ) {
      game.attributes.positions.forEach(item => {
        // 添加除了队长以外的Positions
        if (item && item.id && item.attributes.code !== $const.CAPTAIN) {
          positions.push(item);
        }
      });
    }
    return positions;
  };

  getRoles = game => {
    let roles = [];
    if (game && game.attributes && game.attributes.roles && game.attributes.roles.length > 0) {
      game.attributes.roles.forEach(item => {
        if (item && item.id) {
          roles.push(item);
        }
      });
    }
    return roles;
  };

  render() {
    const game = this.props.gameStore.selectedGame;
    const lang = this.props.languageStore.lang;
    let positions = this.getPostions(game);
    let roles = this.getRoles(game);

    return (
      <div className="select-role">
        <div className="sub-title">
          <Language resource="YOU_WILL_JOIN_IN" />
        </div>
        <div className="team-name">
          {this.props.teamStore.joinInTeamInfo && this.props.teamStore.joinInTeamInfo.collegeName}{" "}
          {this.props.teamStore.joinInTeamInfo && this.props.teamStore.joinInTeamInfo.name}{" "}
          <Language resource="TEAM" />
        </div>
        <div className="sub-title team-info">
          <Language resource="JOIN_IN" />
          {game && game.attributes.title}
          <Language resource="COMPETITION" />
        </div>
        <div className="select">
          <div className="select-item">
            <div className="label">
              <Language resource="YOUR_POSITION" />
            </div>
            <div className="tags">
              {positions.length > 0 &&
                positions.map((item, index) => {
                  return (
                    <CheckableTag
                      key={item.event_position_id}
                      checked={this.state.position === item.event_position_id}
                      onChange={this.handleChangePosition.bind(
                        this,
                        item.event_position_id,
                        item.attributes.name,
                        item.attributes.code
                      )}
                    >
                      {item.attributes.name}
                    </CheckableTag>
                  );
                })}
            </div>
          </div>
          <div className="select-item">
            <div className="label">
              <Language resource="YOUR_ROLE" />
            </div>
            <div className="tags">
              {roles.length > 0 &&
                roles.map((item, index) => {
                  return (
                    <CheckableTag
                      key={item.event_role_id}
                      checked={this.state.role === item.event_role_id}
                      onChange={this.handleChangeRole.bind(this, item.event_role_id)}
                    >
                      {item.attributes.name}
                    </CheckableTag>
                  );
                })}
            </div>
          </div>
          {this.state.checkErrorInfo.length > 0 ? (
            <div className="select-role__error-info-box">
              {this.state.checkErrorInfo.map((item, idx) => {
                const { info } = item;
                return (
                  <div className="select-role__error-info-box--item" key={idx.toString()}>
                    {info[lang]}
                  </div>
                );
              })}
              <div className="select-role__error-info-box--refresh-box">
                <div className="select-role__error-info-box--refresh-info">
                  <Language resource="PERSONAL_INFO_VERFICATION_FAILED" />
                </div>
                <div
                  className="select-role__error-info-box--refresh-link"
                  onClick={() => $util.openPersonalCenter(lang)}
                >
                  <Language resource="UPDATE_PERSONAL_INFO" />
                </div>
              </div>
            </div>
          ) : null}
          <div className={this.state.checkErrorInfo.length > 0 ? "operate--no-margin" : "operate"}>
            <Button
              disabled={!(this.state.position && this.state.role)}
              type="primary"
              className="button"
              loading={this.state.btnIsLoading}
              onClick={this.joinTeam}
            >
              <Language resource="CONFIRM"></Language>
            </Button>
          </div>
        </div>
        <ModalAntd
          footer={null}
          maskClosable={false}
          onCancel={this.closeConfirmPersonalInfoModalState}
          width={"585px"}
          title={<Language resource="CONFIRM_THE_ENTRY_INFO" />}
          destroyOnClose={true}
          visible={this.state.confirmPersonalInfoModalState}
        >
          <ConfirmPersonalInfo
            onClose={() => {
              this.setState({
                confirmPersonalInfoModalState: false
              });
            }}
            onConfirm={this.confirmPersonalInfo}
          />
        </ModalAntd>
        <Modal
          width={this.state.modalWidth}
          title={<Language resource="PERSON_INFO_NOT_COMPLETE" />}
          state={false}
          close={this.closePersonInfoModal}
        >
          <PersonInfoNotice />
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/registrationCenter/selectRole.js